import React, { Fragment } from 'react'
import { Field, WrappedFieldProps } from 'redux-form'
import ReactDOM from 'react-dom'
import { BMultiSelectBeta, BFormGroup, BLabel, BFormText } from '@prague-digi/ui-components'
import classNames from '@prague-digi/class-names'

import styles from './styles.scss'

interface Option {
  value: string | number
  label: string
}

interface Props {
  data: Option[]
  disabled?: boolean
  maxMenuHeight?: number
  messages: {
    label?: string
    notice?: string
    placeholder?: string
    prefix?: string
  }
  name: string
  noMessage?: boolean
  onChange?: (value: any) => void
  testid: string
  theme?: string
}

export class Combobox extends React.Component<Props & WrappedFieldProps> {
  componentDidMount() {
    this.uglySetTestId()
  }

  onChange = (opt: Option) => {
    this.props.input.onChange(opt.value)

    if (this.props.onChange) {
      this.props.onChange(opt.value)
    }
  }

  onBlur = (opt: Option) => {
    this.props.input.onBlur(opt.value)
  }

  uglySetTestId = () => {
    // TODO FIX ESlint
    // eslint-disable-next-line react/no-find-dom-node
    const containerDom = ReactDOM.findDOMNode(this)
    if (containerDom instanceof HTMLElement) {
      const inputDom = containerDom.querySelector(`input[name="${this.props.name}"]`)
      if (inputDom instanceof HTMLElement) {
        inputDom.setAttribute('testid', this.props.testid)
      }
    }
  }

  render() {
    const value =
      this.props.data.find((item: Option) => item.value === this.props.input.value) || ''

    const {
      data,
      disabled,
      maxMenuHeight,
      messages: { label, notice, prefix },
      meta: { error, touched, warning },
      noMessage,
      theme,
    } = this.props

    const select = (
      <BMultiSelectBeta
        data={data}
        disabled={disabled}
        maxMenuHeight={maxMenuHeight}
        menuPortalTarget={document.body}
        messages={{}}
        onBlur={this.onBlur}
        onChange={this.onChange}
        theme={classNames(theme, { [styles.select]: prefix })}
        value={value}
      />
    )

    const hasError = error && touched
    const hasWarning = warning && touched

    return (
      <BFormGroup error={hasError} warning={hasWarning}>
        <BLabel>{label}</BLabel>
        {prefix ? (
          <div className={styles.container}>
            <BFormText theme={styles.prefix}>{prefix}</BFormText>
            {select}
          </div>
        ) : (
          select
        )}
        {!noMessage && (
          <Fragment>
            {notice && <BFormText>{notice}</BFormText>}
            {hasError && <BFormText>{error}</BFormText>}
            {hasWarning && <BFormText>{warning}</BFormText>}
          </Fragment>
        )}
      </BFormGroup>
    )
  }
}

const BCombobox = (props: Props) => <Field {...props} component={Combobox} />

export default BCombobox
